import axios from 'axios';
import { CLIP_BANCA_JSP, CLIP_FUND_JSP, CLIP_LOAN_JSP } from '../constants';
import { EdocTranType } from '../enums';

export const CLIP_PATH_MAP: Record<EdocTranType, string> = {
  [EdocTranType.LOAN]: CLIP_LOAN_JSP,
  [EdocTranType.BANCA]: CLIP_BANCA_JSP,
  [EdocTranType.FUND]: CLIP_FUND_JSP,
  [EdocTranType.CERTIFICATES]: 'clipReportCertificates.jsp',
};

/**
 * clip axios instance
 */
export const ClipClient = (clipUrl: string) => {
  return axios.create({
    baseURL: clipUrl,
    timeout: 60000,
    withCredentials: false,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
  });
};
// export const ClipClient = axios.create({
//   baseURL: clipUrl,
//   timeout: 60000,
//   withCredentials: false,
//   headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
// });
